function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState, useContext, useLayoutEffect } from 'react';
import { disableBodyScroll } from 'body-scroll-lock';
import { captureException } from '@sentry/browser';
import { IconClose, Spacer, mediaMixin, spaceMixin, token, TextButton, Text, IconChevronRightOutline, LoadingMask } from '@zillow/constellation';
import { useApolloClient } from '@apollo/client';
import { Provider } from 'react-redux';
import styled, { css } from 'styled-components';
import { UniversalAnalyticsContext } from '@zillow/universal-analytics-react';
import { createUserSessionStore, connectToUserSession } from '@zillow/user-session-store';
import { useYieldCallback } from '@zillow/yield-callback';
import { getOMPDisplayStatus, NFSOnsiteMessagingWrapper } from '@zillow/home-details-nfs-onsite-messaging';
import { claimHome } from '../utils/claimUtils';
import { trackHdpLinkClick, trackHmimhwReviewLightboxDisplay } from '../utils/gaUtils';
import { getOwnerDashboardUrl } from '../utils/urlUtils';
import ResponsiveLightbox from './ResponsiveLightbox';
import HomeInfo from './HomeInfo';
import HomeValue from './HomeValue';
import SellerLinks from './SellerLinks';
import OmpHomeWorthUpsell from './OmpHomeWorthUpsell';
import ContactFormLightbox from './ContactFormLightBox';
var StyledIconClose = styled(IconClose).withConfig({
  displayName: "HomeDetailLightboxContent__StyledIconClose",
  componentId: "sc-m40l3-0"
})(["color:", ";font-size:18px;position:absolute;right:", ";top:", ";", ";"], token('colors.white'), spaceMixin(2.5), spaceMixin(2.5), mediaMixin('md_lte', css(["top:", ";right:", ";"], spaceMixin(1.25), spaceMixin(1.25))));
var StyledTextButton = styled(TextButton).withConfig({
  displayName: "HomeDetailLightboxContent__StyledTextButton",
  componentId: "sc-m40l3-1"
})(["display:flex;"]);
var StyledIconChevronRightOutline = styled(IconChevronRightOutline).withConfig({
  displayName: "HomeDetailLightboxContent__StyledIconChevronRightOutline",
  componentId: "sc-m40l3-2"
})(["color:", ";position:absolute;top:1px;"], token('colors.white'));
export var UnwrappedHomeDetailLightboxContent = function UnwrappedHomeDetailLightboxContent(_ref) {
  var loggedIn = _ref.loggedIn,
      setZpid = _ref.setZpid,
      zatlasEndpoint = _ref.zatlasEndpoint,
      surfaceId = _ref.surfaceId,
      placementId = _ref.placementId,
      property = _ref.property,
      abTests = _ref.abTests,
      viewer = _ref.viewer,
      isLightboxBackgroundLocked = _ref.isLightboxBackgroundLocked,
      setHmimhwAnalyticsData = _ref.setHmimhwAnalyticsData,
      isCMS = _ref.isCMS;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showContactAgentForm = _useState2[0],
      setShowContactAgentForm = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isClaimInFlight = _useState4[0],
      setIsClaimInFlight = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isSuccessfullyClaimed = _useState6[0],
      setIsSuccessfullyClaimed = _useState6[1];

  var _useContext = useContext(UniversalAnalyticsContext),
      areRequiredDimensionsSet = _useContext.areRequiredDimensionsSet,
      resetRequiredCustomDimensions = _useContext.resetRequiredCustomDimensions;

  useEffect(function () {
    if (!showContactAgentForm && areRequiredDimensionsSet) {
      trackHmimhwReviewLightboxDisplay(surfaceId, placementId);
    }
  }, [showContactAgentForm, areRequiredDimensionsSet, surfaceId, placementId]);
  var client = useApolloClient();
  useLayoutEffect(function () {
    var scrollTarget = document.querySelector('.scrollTarget');

    if (isLightboxBackgroundLocked) {
      disableBodyScroll(scrollTarget);
    }
  }, [isLightboxBackgroundLocked]);
  useEffect(function () {
    var triggerClaim = function triggerClaim() {
      return new Promise(function ($return, $error) {
        if (loggedIn && !property.isConfirmedClaimedByCurrentSignedInUser && !property.isVerifiedClaimedByCurrentSignedInUser && property.zpid) {
          var $Try_3_Finally = function ($Try_3_Exit) {
            return function ($Try_3_Value) {
              try {
                setIsClaimInFlight(false);
                return $Try_3_Exit && $Try_3_Exit.call(this, $Try_3_Value);
              } catch ($boundEx) {
                return $error($boundEx);
              }
            }.bind(this);
          }.bind(this);

          setIsClaimInFlight(true);

          var $Try_3_Post = function () {
            try {
              return $If_4.call(this);
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }.bind(this);

          var $Try_3_Catch = function (error) {
            try {
              setIsSuccessfullyClaimed(false);
              captureException(error);
              return $Try_3_Finally($Try_3_Post)();
            } catch ($boundEx) {
              return $Try_3_Finally($error)($boundEx);
            }
          };

          try {
            return Promise.resolve(claimHome(client, property.zpid, 'HMMHW_LP')).then(function ($await_5) {
              try {
                setIsSuccessfullyClaimed(true);
                return $Try_3_Finally($Try_3_Post)();
              } catch ($boundEx) {
                return $Try_3_Catch($boundEx);
              }
            }, $Try_3_Catch);
          } catch (error) {
            $Try_3_Catch(error)
          }
        }

        function $If_4() {
          return $return();
        }

        return $If_4.call(this);
      });
    };

    void triggerClaim();
  }, [property.zpid, loggedIn, property, surfaceId, placementId, client]);
  var onHDPLinkClick = useYieldCallback(function () {
    trackHdpLinkClick(surfaceId, placementId);
  });

  if (showContactAgentForm) {
    return /*#__PURE__*/React.createElement(ContactFormLightbox, {
      property: property,
      viewer: viewer,
      setShowContactAgentForm: setShowContactAgentForm,
      zatlasEndpoint: zatlasEndpoint,
      surfaceId: surfaceId,
      placementId: placementId,
      isLightboxBackgroundLocked: isLightboxBackgroundLocked
    });
  }
  /**
   * This is to get whether OMP upsell can actually display
   * full content when OMP is eligible to show. here is the function return object:
   * {
   *   showFullOMP: Boolean //OMP upsell content can be show fully
   *   showEmptyOMP: Boolean // OMP have empty content but need to render to trigger DSP event
   * }
   */


  var OMPStatus = getOMPDisplayStatus({
    messageData: property.onsiteMessage,
    placementName: 'HMIMHWTopSlot'
  });
  var showOMPUpsell = OMPStatus.showFullOMP;
  var additionalProps = {
    signalForTriggerTracking: areRequiredDimensionsSet
  };
  return /*#__PURE__*/React.createElement(ResponsiveLightbox, {
    isLightboxBackgroundLocked: isLightboxBackgroundLocked,
    isCMS: isCMS
  }, /*#__PURE__*/React.createElement(HomeInfo, {
    property: property,
    abTests: abTests,
    "data-testid": "home-info",
    ownerDashboardLink: /*#__PURE__*/React.createElement(LoadingMask, {
      loading: isClaimInFlight,
      iconSize: "sm"
    }, /*#__PURE__*/React.createElement(TextButton, {
      as: "a",
      onClick: onHDPLinkClick,
      href: getOwnerDashboardUrl(property.zpid, isSuccessfullyClaimed)
    }, /*#__PURE__*/React.createElement(Text, {
      fontType: "body",
      fontColor: "white"
    }, "View this home", /*#__PURE__*/React.createElement(StyledIconChevronRightOutline, null))))
  }), /*#__PURE__*/React.createElement(Spacer, {
    marginTop: "sm",
    marginBottom: "xs"
  }, /*#__PURE__*/React.createElement(HomeValue, {
    zestimate: property.zestimate,
    "data-testid": "home-value"
  })), /*#__PURE__*/React.createElement(Spacer, {
    marginTop: "sm"
  }, showOMPUpsell ? /*#__PURE__*/React.createElement(OmpHomeWorthUpsell, {
    property: property,
    abTests: abTests,
    additionalProps: additionalProps
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, OMPStatus.showEmptyOMP && /*#__PURE__*/React.createElement(NFSOnsiteMessagingWrapper, {
    abBucket: abTests.HMIMHW_ZO_NFS_UPSELL_ONSITE_MESSAGING,
    messageData: property.onsiteMessage,
    additionalProps: additionalProps,
    placementName: "HMIMHWTopSlot"
  }), /*#__PURE__*/React.createElement(SellerLinks, {
    property: property,
    abTests: abTests,
    setShowContactAgentForm: setShowContactAgentForm,
    surfaceId: surfaceId,
    placementId: placementId
  }))), /*#__PURE__*/React.createElement(StyledTextButton, {
    "data-testid": "close-button",
    onClick: function onClick() {
      setZpid(null);
      setHmimhwAnalyticsData(null);

      if (typeof resetRequiredCustomDimensions === 'function') {
        resetRequiredCustomDimensions();
      }
    },
    icon: /*#__PURE__*/React.createElement(StyledIconClose, null)
  }));
};
/* eslint-disable zillow/@typescript-eslint/no-unsafe-assignment */

var HomeDetailLightboxContentContainer = connectToUserSession(function (state) {
  return {
    loggedIn: state.user.loggedIn
  };
})(UnwrappedHomeDetailLightboxContent);

var HomeDetailLightboxContent = function HomeDetailLightboxContent(props) {
  return /*#__PURE__*/React.createElement(Provider, {
    store: createUserSessionStore()
  }, /*#__PURE__*/React.createElement(HomeDetailLightboxContentContainer, props));
};
/* eslint-enable zillow/@typescript-eslint/no-unsafe-assignment */


export default HomeDetailLightboxContent;
//# sourceMappingURL=HomeDetailLightboxContent.js.map